import React from "react";

const O365Success = () => {
  const handleOk = () => {
    // Send success message to parent only when OK is clicked
    window.opener.postMessage(
      { type: "O365_INTEGRATION_SUCCESS", payload: {} },
      "*"
    );
    window.close();
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen text-center p-6 bg-white">
      <img
        src="/images/office365_logo.png"
        alt="Success"
        className="w-32 mb-6"
      />
      <h2>Office365 </h2>
      <h3 className="text-2xl font-semibold text-gray-800">
        Integration Successful!
      </h3>
      <p className="mb-6">Your integration has been completed successfully.</p>

      <button
        onClick={handleOk}
        className="mt-6 px-6 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700"
      >
        OK
      </button>
    </div>
  );
};

export default O365Success;
